export default function filterByDaysLeft(advertisers, selectedDays) {
    return advertisers.filter(advertiser => {
        // Convert budget values to numbers
        const monthlyBudget = parseFloat(advertiser?.monthlyBudget);
        const monthSpent = parseFloat(advertiser?.monthlySpend)
        const dailyBudget = parseFloat(advertiser?.dailyBudget);
        const expense = parseFloat(advertiser?.expense)
        const monthLeftBudget = monthlyBudget - (monthSpent + expense);

        // Handle edge case where dailyBudget is 0
        if (dailyBudget === 0 || !monthlyBudget || monthlyBudget < monthSpent) {
            return selectedDays === 0; // Return true only for "0 days" filter
        }

        // Calculate the ratio (days of budget left)
        const ratio = monthLeftBudget / dailyBudget;
        const floorRatio = Math.floor(ratio);

        // Filter based on selected days
        switch (selectedDays) {
            case '0':
                return ratio < 1; // Less than 1 day left
            case '1':
                return floorRatio === 1; // Exactly 1 day (1 <= ratio < 2)
            case '2':
                return floorRatio === 2; // Exactly 2 days (2 <= ratio < 3)
            case '3':
                return floorRatio === 3; // Exactly 3 days (3 <= ratio < 4)
            // case '4':
            //     return floorRatio === 4; // Exactly 4 days (4 <= ratio < 5)
            case "more":
            case "3+":
                return floorRatio > 3; // More than 4 days
            default:
                return false;
        }
    });
}